import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "@/components/ui/dialog";

import { Label } from "@/components/ui/label";
import { AutoComplete } from "@/components/AutoCompleteInput";
import { useCustomParametersStore } from "./custom-parameters-store";
import { getModels } from "../utils";
import { useFormContext } from "react-hook-form";
import { useState } from "react";
import { BookIcon } from "lucide-react";

export const InheritParametersDialog = () => {
  const store = useCustomParametersStore();
  const form = useFormContext();
  const [selectedModel, setSelectedModel] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const { modelsList, isViewing } = store;

  const modelName = form.getValues("create_custom_model.modelName");
  const provider = form.getValues("create_custom_model.provider");

  const isInheritable =
    (store.inheritableParameters(modelName, provider)?.length ?? 0) > 0;

  const isKnownModel = store.getKnownModel(modelName, provider);

  const onClick = () => {
    if (isKnownModel || selectedModel) {
      store.inheritParameters(selectedModel || modelName, provider);
      setIsOpen(false);
      setSelectedModel("");

      return;
    }

    setIsOpen(true);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <Button
        onClick={onClick}
        disabled={Boolean(!isInheritable && isKnownModel) || isViewing}
        variant="ghost"
        type="button"
      >
        <BookIcon className="mr-2 h-4 w-4" />
        Inherit parameters
      </Button>
      <DialogContent className="flex flex-col gap-4">
        <DialogTitle>Inherit parameters</DialogTitle>
        <DialogDescription>
          We were unable to find any parameters for this model. Please select a
          model to inherit parameters from.
        </DialogDescription>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <Label>Model</Label>
            <AutoComplete
              addNewOption={false}
              options={getModels(modelsList, provider)}
              value={selectedModel}
              onChange={(value) => setSelectedModel(value ?? "")}
              placeholder="Select a model"
              size="small"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={onClick}>Inherit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
